import { Grid } from "../../components/section";
import { PopUpRight } from "../../components/popups";
import ReactPlayer from "react-player";
import { Text } from "../../components/typography";
import styled from "styled-components";

export const VideoDetailFetch = ({
  video,
  title,
  description,
  open,
  onToggleOpenClose,
  ...otherProps
}) => {
  return (
    <>
      <PopUpRight
        title={title}
        open={open}
        width="90%"
        onToggleOpenClose={onToggleOpenClose}
      >
        {
          <>
            {console.log("Video:", video)}
            {otherProps.components && otherProps.components}
            <BaseGallery col="2">
              <ReactPlayer url={video} width="100%" height="100%" />
            </BaseGallery>
            <Text>{description}</Text>
          </>
        }
      </PopUpRight>
    </>
  );
};

export default VideoDetailFetch;

const BaseGallery = styled(Grid)`
  grid-template-columns: 1fr;
  height: 100%;
  margin-bottom: 1rem;
`;
